import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CardItem from '@/views/review/components/card-list/card-item.vue';
import DarkBg from '@/components/dark-bg.vue';
import { BATCH_CARD_RADIO_LIST } from '@/views/review/constant.js';
import { queryTaskInfo as _queryTaskInfo, recordAnswer } from '@/api/review.js';
export default {
  name: 'BatchCard',
  components: {
    CardItem: CardItem,
    DarkBg: DarkBg
  },
  props: {
    subjectCode: {
      type: Number,
      default: 0
    },
    taskId: {
      type: Number,
      default: 0
    },
    queryTaskList: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      radioList: BATCH_CARD_RADIO_LIST,
      cardStatus: -1,
      // -1 全部 1 新卡 2 复习卡
      isCheckAll: false,
      // 是否全选
      checkArr: [],
      cardList: [],
      pageNum: 1,
      pageSize: 20,
      total: 0
    };
  },
  computed: {
    checkLen: function checkLen() {
      return this.checkArr.length;
    },
    cardEmptyText: function cardEmptyText() {
      return this.cardRadio === 2 ? '暂无复习卡' : '暂无卡片';
    }
  },
  created: function created() {
    this.cardList = [];
    this.checkArr = [];
    this.queryTaskInfo();
  },
  methods: {
    // 今日待做任务卡片列表
    queryTaskInfo: function queryTaskInfo() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_queryTaskInfo, status, data, total, list;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _queryTaskInfo({
                  subjectId: _this.subjectCode,
                  cardStatus: _this.cardStatus,
                  pageSize: _this.pageSize,
                  pageNumber: _this.pageNum
                });

              case 2:
                _yield$_queryTaskInfo = _context.sent;
                status = _yield$_queryTaskInfo.status;
                data = _yield$_queryTaskInfo.data;

                if (!(status !== 1)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                total = data.total, list = data.list;
                _this.total = total || 0;
                _this.cardList = list || [];

                _this.judgeCheckAll();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 分页
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNum = val;
      this.queryTaskInfo();
    },
    // 切换radio
    handleRadio: function handleRadio(id) {
      if (this.cardStatus === id) return;
      this.cardStatus = id;
      this.pageNum = 1;
      this.cardList = [];
      this.queryTaskInfo();
    },
    // 单个选
    handleCheck: function handleCheck(item) {
      var reviewTaskCardId = item.reviewTaskCardId;
      var index = this.checkArr.indexOf(reviewTaskCardId);

      if (index !== -1) {
        this.checkArr.splice(index, 1);
      } else {
        this.checkArr.push(reviewTaskCardId);
      }

      this.judgeCheckAll();
    },
    // 全选
    handleAllCheck: function handleAllCheck() {
      var _this2 = this;

      this.isCheckAll = !this.isCheckAll;
      this.cardList.forEach(function (item) {
        var reviewTaskCardId = item.reviewTaskCardId;

        var index = _this2.checkArr.indexOf(reviewTaskCardId);

        if (_this2.isCheckAll && index === -1) {
          _this2.checkArr.push(reviewTaskCardId);
        } else if (!_this2.isCheckAll && index !== -1) {
          _this2.checkArr.splice(index, 1);
        }
      });
    },
    // 判断是否全选
    judgeCheckAll: function judgeCheckAll() {
      var _this3 = this;

      if (this.cardList.length) {
        this.isCheckAll = this.cardList.every(function (item) {
          var reviewTaskCardId = item.reviewTaskCardId;
          return _this3.checkArr.includes(reviewTaskCardId);
        });
      } else {
        this.isCheckAll = false;
      }
    },
    // 3明日复习 2已掌握
    handleRecordAnswer: function handleRecordAnswer(cmd) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var cardAnswerList, _yield$recordAnswer, status;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cardAnswerList = _this4.checkArr.map(function (item) {
                  return {
                    taskCardId: item
                  };
                });
                _context2.next = 3;
                return recordAnswer({
                  taskId: _this4.taskId,
                  cmd: cmd,
                  // 1:学生作答,2:已掌握,3:明天复习,4:查看答案
                  cardAnswerList: cardAnswerList,
                  type: 2 // 批量作答埋点 1：正常作答，2：批量作答，3：弹窗作答

                });

              case 3:
                _yield$recordAnswer = _context2.sent;
                status = _yield$recordAnswer.status;

                if (!(status !== 1)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                _this4.$message.success('操作成功');

                _this4.pageNum = 1; // 明日复习，已掌握后 自动回到第一页

                _this4.cardList = [];
                _this4.checkArr = [];

                _this4.queryTaskInfo();

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 关闭
    handleClose: function handleClose() {
      this.queryTaskList(1, 'update'); // 刷新复习首页的卡片列表第一页

      this.$attrs.close();
    }
  }
};